document.addEventListener("DOMContentLoaded", function () {
	const tabsBlocks = document.querySelectorAll(".ornl-tabs, .wp-block-ornl-tabs");

	tabsBlocks.forEach(function (tabsBlock) {
		initializeTabs(tabsBlock);
	});

	function initializeTabs(tabsBlock) {
		if (tabsBlock.dataset.tabsInitialized === "true") {
			return;
		}

		const tabButtons = tabsBlock.querySelectorAll(
			":scope > .tabs-navigation .tab-button",
		);
		const tabPanels = tabsBlock.querySelectorAll(
			":scope > .tabs-content > .tab-panel",
		);
		const activeTabIndex = parseInt(tabsBlock.dataset.activeTab, 10) || 0;

		if (tabButtons.length === 0 || tabPanels.length === 0) {
			return;
		}

		tabsBlock.dataset.tabsInitialized = "true";
		const hash = window.location.hash.slice(1);
		const hashTabIndex = hash
			? Array.from(tabButtons).findIndex((button) => button.dataset.tabAnchor === hash)
			: -1;
		setActiveTab(hashTabIndex >= 0 ? hashTabIndex : Math.min(activeTabIndex, tabButtons.length - 1), false);

		tabButtons.forEach(function (button, index) {
			button.addEventListener("click", function (event) {
				event.preventDefault();
				setActiveTab(index);
			});

			button.addEventListener("keydown", function (event) {
				let targetIndex = index;

				switch (event.key) {
					case "ArrowLeft":
						event.preventDefault();
						targetIndex = index > 0 ? index - 1 : tabButtons.length - 1;
						break;
					case "ArrowRight":
						event.preventDefault();
						targetIndex = index < tabButtons.length - 1 ? index + 1 : 0;
						break;
					case "Home":
						event.preventDefault();
						targetIndex = 0;
						break;
					case "End":
						event.preventDefault();
						targetIndex = tabButtons.length - 1;
						break;
					case "Enter":
					case " ":
						event.preventDefault();
						setActiveTab(index);
						return;
					default:
						return;
				}

				tabButtons[targetIndex].focus();
			});
		});

		function setActiveTab(index, shouldAnnounce = true) {
			tabPanels.forEach(function (panel, panelIndex) {
				const isActive = panelIndex === index;

				panel.hidden = !isActive;
				panel.classList.toggle("active", isActive);
			});

			tabButtons.forEach(function (button, buttonIndex) {
				const isActive = buttonIndex === index;

				button.classList.toggle("active", isActive);
				button.setAttribute("aria-selected", isActive ? "true" : "false");
				button.setAttribute("tabindex", isActive ? "0" : "-1");
			});

			tabsBlock.dataset.activeTab = index;

			if (shouldAnnounce) {
				announceTabChange(
					tabButtons[index].textContent.trim(),
					index + 1,
					tabButtons.length,
				);
			}
		}

		function announceTabChange(tabName, currentTab, totalTabs) {
			const tabsId = tabsBlock.dataset.tabsId || tabsBlock.id || "tabs";
			const liveRegionId = `tabs-live-region-${tabsId}`;
			let liveRegion = tabsBlock.querySelector(`#${liveRegionId}`);

			if (!liveRegion) {
				liveRegion = document.createElement("div");
				liveRegion.id = liveRegionId;
				liveRegion.setAttribute("aria-live", "polite");
				liveRegion.setAttribute("aria-atomic", "true");
				liveRegion.style.position = "absolute";
				liveRegion.style.left = "-10000px";
				liveRegion.style.width = "1px";
				liveRegion.style.height = "1px";
				liveRegion.style.overflow = "hidden";
				tabsBlock.appendChild(liveRegion);
			}

			liveRegion.textContent = `${tabName} tab selected. ${currentTab} of ${totalTabs}`;
		}
	}
});
